export default "__VITE_ASSET__ByXtPHlC__"